import { StyledEngineProvider } from '@mui/material/styles';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Spinner from '../../components/spinner/Spinner.component';
import { GameContext } from '../../core/context/game.context';
import { PlaySummary } from '../../core/interfaces/challenge.interface';
import { getPlaySummary, sharePlay } from '../../core/rest/challenge.service';
import Summary from './Summary.component';
import { EmailReq } from './summary.interface';

export default function SummaryService() {
  const [loadingState, setLoadingState] = React.useState(false);
  const [summaryState, setSummaryState] = React.useState<PlaySummary>();
  const gameCtx = React.useContext(GameContext);
  const navigate = useNavigate();
  const instance = gameCtx.getInstance();
  const preset = gameCtx.getPreset();
  const language = gameCtx.values.language;
  const playId = gameCtx.values.playId;
  const instanceId = instance?.id;
  const instanceName = instance?.name;
  const presetId = preset?.id;
  const presetName = preset?.name;
  const score =
    gameCtx.values.score >= 0
      ? gameCtx.values.score
      : (summaryState?.play.number_correct_answers ?? 0) * (preset?.stepScore ?? 0);

  React.useEffect(() => {
    if (!instanceId || !instanceName || !presetId || !presetName) {
      return;
    }

    if (!playId) {
      navigate(`/${language}/${instanceId}/${instanceName}/${presetId}/${presetName}`, {
        replace: true,
      });
      return;
    }

    let mounted = true;

    setLoadingState(true);
    getPlaySummary(playId)
      .then((summary) => {
        if (mounted) {
          setSummaryState(summary);
        }
      })
      .finally(() => {
        if (mounted) {
          setLoadingState(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, [language, playId, instanceId, instanceName, presetId, presetName, navigate]);

  function sendEmail(value: EmailReq): Promise<undefined> {
    return sharePlay(playId, { recipient: value.recipientEmail });
  }

  return (
    <section className="SummaryServiceComponent">
      {loadingState ? <Spinner primaryColor="#7DDC55" secondaryColor="#FE6E5C" /> : null}
      <StyledEngineProvider injectFirst>
        {gameCtx.getInstance() && <Summary score={score} summary={summaryState} onSend={sendEmail} />}
      </StyledEngineProvider>
    </section>
  );
}
